import React from "react";
import cssClasses from "./BankDetailForm.module.css";
import CustomInput from "../../Subcomponents/CustomInput";
import { useState } from "react";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { getPAN_cardDetails } from "../../Services/SurepassApi";
import { useRef } from "react";
import { debounce } from "lodash";
import DropDown from "../../Subcomponents/DropDown";
import Button from "../../Subcomponents/Button";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import {
  BankFormSubmit,
  BankFormUpdate,
  getBankAccDetails,
  getBankDetailStatus,
  getPanAndBankConfirmationDetails,
} from "../../Services/Bank";
import { errorTost, infoTost, successTost } from "../../Services/Toast";
import logo from "../../Assets/Images/SideMenu/vjLogo.jpg";

const BankDetailForm = () => {
  const [panSuccess, setPanSuccess] = useState(false);
  const [accSuccess, setAccSuccess] = useState(false);
  const [isBankDetailAvailable, setIsBankDetailAvailable] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [panNumberDetails, setPanNumberDetails] = useState();
  const [displayStatusMsg, setDisplayStatusMsg] = useState("");
  const [isRequestRejected, setIsRequestRejected] = useState(false);
  const [updatedData, setUpdatedData] = useState(false);
  const [bookingForm, setBookingForm] = useState({
    panNumber: "",
    customerBankDetails: {
      accountNo: "",
      ifscCode: "",
      accHolderName: "",
      accType: "",
      bankName: "",
    },
  });
  const [helperText, setHelperText] = useState({
    panNumber: "",
    accNumber: "",
    ifsc: "",
    bankName: "",
    accType: "",
  });

  const handleAccNoChange = useRef(
    debounce((e) => {
      presentLoader();
      setAccSuccess(false);
      if (e === "") {
        setHelperText((pre) => {
          pre.accNumber = "Please enter bank account number";
          return { ...pre };
        });
      } else {
        // presentLoader();
        if (e.length > 0) {
          if (
            bookingForm.customerBankDetails.ifscCode &&
            bookingForm.customerBankDetails.ifscCode !== ""
          ) {
            // presentLoader();
            let bankObj = {
              accountNo: e,
              ifscCode: bookingForm.customerBankDetails.ifscCode,
            };
            getBankAccDetails(bankObj)
              .then((resp) => {
                if (resp.data.message_code === "success") {
                  setAccSuccess(true);
                  setBookingForm((pre) => {
                    resp.data.data.full_name = resp.data.data.full_name.trim();
                    pre.customerBankDetails.accHolderName =
                      resp.data.data.full_name;
                    return { ...pre };
                  });
                  setHelperText((pre) => {
                    pre.accNumber = "";
                    pre.ifsc = "";
                    return { ...pre };
                  });
                  dismissLoader();
                  // setHelperText((pre) => {
                  //     pre.ifsc = ''
                  //     return { ...pre }
                  // })
                } else {
                  dismissLoader();
                  setHelperText((pre) => {
                    pre.accNumber = "Incorrect bank account number";
                    return { ...pre };
                  });
                }
              })
              .catch((err) => {
                dismissLoader();
                setHelperText((pre) => {
                  pre.accNumber = "Incorrect bank account number";
                  return { ...pre };
                });
              });
            dismissLoader();
            setHelperText((pre) => {
              pre.accNumber = "";
              pre.ifsc = "";
              return { ...pre };
            });
            // setBookingForm((pre) => {
            //   // resp.data.data.full_name = resp.data.data.full_name.trim()
            //   pre.customerBankDetails.accHolderName = pre.firstName;
            //   return { ...pre };
            // });
          } else {
            dismissLoader();
            setHelperText((pre) => {
              pre.accNumber = "";
              return { ...pre };
            });
          }
        } else {
          dismissLoader();
          setHelperText((pre) => {
            pre.accNumber = "Please enter bank account number";
            return { ...pre };
          });
        }
      }
    }, 1000)
  ).current;

  function validateForm() {
    let flag = true;
    if (bookingForm.panNumber === "") {
      flag = false;
      setHelperText((pre) => {
        pre.panNumber = "Please enter pan card number";
        return { ...pre };
      });
    }
    if (bookingForm.customerBankDetails.accountNo === "") {
      flag = false;
      setHelperText((pre) => {
        pre.accNumber = "Please enter bank account number";
        return { ...pre };
      });
    }
    if (bookingForm.customerBankDetails.ifscCode === "") {
      flag = false;
      setHelperText((pre) => {
        pre.ifsc = "Please enter ifsc code";
        return { ...pre };
      });
    }
    if (
      !bookingForm.customerBankDetails.bankName ||
      bookingForm.customerBankDetails.bankName === ""
    ) {
      flag = false;
      setHelperText((pre) => {
        pre.bankName = "Please enter bank name";
        return { ...pre };
      });
    }
    if (bookingForm.customerBankDetails.accType === "") {
      flag = false;
      setHelperText((pre) => {
        pre.accType = "Please enter account type";
        return { ...pre };
      });
    }
    return flag;
  }

  async function saveForm() {
    let flag = validateForm();
    if (flag) {
      setOpenConfirmationModal(true);
    }
  }

  function ModalResp(e) {
    if (e === "confirmed") {
      if (
        bookingForm.customerBankDetails?.accHolderName
          ?.toLowerCase()
          .includes(panNumberDetails?.description?.toLowerCase())
      ) {
        setBookingForm((pre) => {
          pre.isFlagged = false;

          return { ...pre };
        });
      } else {
        setBookingForm((pre) => {
          pre.isFlagged = true;
          return { ...pre };
        });
      }
      presentLoader();
      setOpenConfirmationModal(false);
      if (updatedData) {
        BankFormUpdate(
          { ...bookingForm, status: "pending" },
          bookingForm?.panNumber
        )
          .then(() => {
            dismissLoader();
            setDisplayStatusMsg("");
            setIsBankDetailAvailable(false);
            setPanSuccess(false);
            setAccSuccess(false);
            setBookingForm({
              panNumber: "",
              customerBankDetails: {
                accountNo: "",
                ifscCode: "",
                accHolderName: "",
                accType: "",
                bankName: "",
              },
            });
            setUpdatedData();
            successTost("Bank details updated successfully.");
          })
          .catch((err) => {
            dismissLoader();
            if (
              err.message.includes(
                "duplicate key value violates unique constraint"
              )
            ) {
              errorTost("Bank details with this PAN number already exists");
            } else {
              errorTost(err.message);
            }
          });
      } else {
        BankFormSubmit(bookingForm)
          .then(() => {
            dismissLoader();
            setBookingForm({
              panNumber: "",
              customerBankDetails: {
                accountNo: "",
                ifscCode: "",
                accHolderName: "",
                accType: "",
                bankName: "",
              },
            });
            setUpdatedData();
            setIsBankDetailAvailable(false);
            setPanSuccess(false);
            setAccSuccess(false);
            setDisplayStatusMsg("");
            successTost("Bank details submitted successfully.");
          })
          .catch((err) => {
            dismissLoader();
            if (
              err.message.includes(
                "duplicate key value violates unique constraint"
              )
            ) {
              errorTost("Bank details with this PAN number already exists");
            } else {
              errorTost(err.message);
            }
          });
      }
    }
  }

  return (
    <div className={cssClasses.FormContainer}>
      <img src={logo} style={{ width: "40rem" }} alt="icon" />
      <div className={cssClasses.fieldWrapper}>
        <div style={{ width: "50%" }}>
          <CustomInput
            style={{ textTransform: "uppercase" }}
            handleChange={(e) => {
              setPanSuccess(false);
              setBookingForm((pre) => {
                pre.panNumber = e.toUpperCase();
                if (e === "") {
                  setDisplayStatusMsg("");
                  setUpdatedData();
                  setHelperText((pre) => {
                    pre.panNumber = "Please enter pan card number";
                    return { ...pre };
                  });
                } else {
                  if (e.length === 10) {
                    setHelperText((pre) => {
                      pre.panNumber = "";
                      return { ...pre };
                    });
                    presentLoader();
                    getPAN_cardDetails(e.toUpperCase())
                      .then((resp) => {
                        if (resp.data.message_code === "success") {
                          setPanSuccess(true);
                          setIsBankDetailAvailable(true);
                          getBankDetailStatus(e.toUpperCase())
                            .then((val) => {
                              if (val?.data[0]?.status === "pending") {
                                dismissLoader();
                                setIsRequestRejected(false);
                                setIsBankDetailAvailable(true);
                                setDisplayStatusMsg(
                                  "Your refund request is pending"
                                );
                              }
                              if (val?.data[0]?.status === "accepted") {
                                dismissLoader();
                                setIsRequestRejected(false);
                                setIsBankDetailAvailable(true);
                                setDisplayStatusMsg(
                                  "Your refund request has been accepted. Please contact your  CRM  for more details"
                                );
                              }
                              if (
                                val.data[0]?.status === "rejected" ||
                                val?.data?.length === 0
                              ) {
                                val.data[0]?.status === "rejected" &&
                                  setDisplayStatusMsg(
                                    "Your refund request has been rejected. Kindly provide updated details"
                                  );
                                val?.data?.length === 0 &&
                                  setDisplayStatusMsg("");
                                setIsRequestRejected(true);
                                val?.data?.length > 0 &&
                                  setUpdatedData({
                                    ...val?.data[0]?.customerBankDetails,
                                  });
                                val?.data?.length > 0 &&
                                  setBookingForm({
                                    panNumber: val?.data[0]?.panNumber,
                                    customerBankDetails: {
                                      ...val?.data[0]?.customerBankDetails,
                                    },
                                  });
                                getPanAndBankConfirmationDetails(
                                  e.toUpperCase()
                                )
                                  .then((resp) => {
                                    dismissLoader();
                                    if (resp?.data?.status === true) {
                                      setPanNumberDetails({
                                        description:
                                          resp?.data?.data?.custdata
                                            ?.FirstName +
                                          " " +
                                          resp?.data?.data?.custdata
                                            ?.MiddleName +
                                          (resp?.data?.data?.custdata
                                            ?.MiddleName
                                            ? " "
                                            : "") +
                                          resp?.data?.data?.custdata?.LastName,
                                        email:
                                          resp?.data?.data?.custdata?.Email,
                                        mobile:
                                          resp?.data?.data?.custdata?.MObile,
                                        UDF_16:
                                          resp?.data?.data?.custdata?.UDF_16,
                                      });
                                      setIsBankDetailAvailable(true);
                                    } else {
                                      setIsBankDetailAvailable(false);
                                    }
                                  })
                                  .catch((err) => {
                                    dismissLoader();
                                    setIsBankDetailAvailable(false);
                                  });
                              }
                            })
                            .catch((err) => {
                              dismissLoader();
                              errorTost(err.message);
                            });
                        }
                      })
                      .catch((err) => {
                        dismissLoader();
                        setHelperText((pre) => {
                          pre.panNumber = "Incorrect Pan Number";
                          pre.accNumber = "";
                          pre.ifsc = "";
                          pre.bankName = "";
                          pre.accType = "";
                          return { ...pre };
                        });
                        setBookingForm((pre) => {
                          pre.customerBankDetails.accountNo = "";
                          pre.customerBankDetails.ifscCode = "";
                          pre.customerBankDetails.accHolderName = "";
                          pre.customerBankDetails.accType = "";
                          pre.customerBankDetails.bankName = "";

                          return { ...pre };
                        });
                      });
                  } else {
                    setDisplayStatusMsg("");
                    setUpdatedData();
                    setHelperText((pre) => {
                      pre.panNumber = "Pan number should be 10 digits";
                      pre.accNumber = "";
                      pre.ifsc = "";
                      pre.bankName = "";
                      pre.accType = "";
                      return { ...pre };
                    });
                    setBookingForm((pre) => {
                      pre.customerBankDetails.accountNo = "";
                      pre.customerBankDetails.ifscCode = "";
                      pre.customerBankDetails.accHolderName = "";
                      pre.customerBankDetails.accType = "";
                      pre.customerBankDetails.bankName = "";

                      return { ...pre };
                    });
                  }
                }
                return { ...pre };
              });
            }}
            greenTick={panSuccess}
            placeholder={"Pan Card Number"}
            label={"Pan Card Number"}
            inputType={"text"}
            mandatory={true}
            helperText={helperText.panNumber}
            value={bookingForm.panNumber}
          />
        </div>
        {displayStatusMsg !== "" && (
          <span className={cssClasses.errLabel}>{displayStatusMsg}</span>
        )}
        {isRequestRejected && panSuccess && !isBankDetailAvailable ? (
          <span className={cssClasses.errLabel}>
            No booking found with this PAN Number
          </span>
        ) : isRequestRejected && panSuccess && isBankDetailAvailable ? (
          <div className={cssClasses.bankDetailWrapper}>
            <div style={{ width: "50%" }}>
              <CustomInput
                // style={{ textTransform: 'uppercase' }}
                handleChange={(e) => {
                  if (isNaN(e)) {
                    return;
                  }
                  const onlyNums = e.replace(/[^0-9]/g, "");
                  setBookingForm((pre) => {
                    pre.customerBankDetails.accHolderName = "";
                    pre.customerBankDetails.accountNo = onlyNums;
                    return { ...pre };
                  });
                  // presentLoader();
                  handleAccNoChange(onlyNums);
                }}
                greenTick={accSuccess}
                placeholder={"Bank Account Number"}
                label={"Bank Account Number"}
                inputType={"text"}
                mandatory={true}
                helperText={helperText.accNumber}
                value={bookingForm.customerBankDetails.accountNo}
              />
            </div>
            <div style={{ width: "50%" }}>
              <CustomInput
                style={{ textTransform: "uppercase" }}
                handleChange={(e) => {
                  setAccSuccess(false);
                  setBookingForm((pre) => {
                    pre.customerBankDetails.accHolderName = "";
                    pre.customerBankDetails.ifscCode = e;
                    if (e === "") {
                      setHelperText((pre) => {
                        pre.ifsc = "Please enter ifsc code";
                        return { ...pre };
                      });
                    } else {
                      if (e.length === 11) {
                        if (
                          pre.customerBankDetails.accountNo &&
                          pre.customerBankDetails.accountNo !== ""
                        ) {
                          presentLoader();
                          let bankObj = {
                            accountNo: pre.customerBankDetails.accountNo,
                            ifscCode: e,
                          };
                          getBankAccDetails(bankObj)
                            .then((resp) => {
                              if (resp.data.message_code === "success") {
                                setAccSuccess(true);
                                setBookingForm((pre) => {
                                  resp.data.data.full_name =
                                    resp.data.data.full_name.trim();
                                  pre.customerBankDetails.accHolderName =
                                    resp.data.data.full_name;
                                  return { ...pre };
                                });
                                setHelperText((pre) => {
                                  pre.accNumber = "";
                                  pre.ifsc = "";
                                  return { ...pre };
                                });
                                dismissLoader();
                                // setHelperText((pre) => {
                                //     pre.ifsc = ''
                                //     return { ...pre }
                                // })
                              }
                            })
                            .catch((err) => {
                              dismissLoader();
                              setHelperText((pre) => {
                                pre.ifsc = "Incorrect ifsc code";
                                return { ...pre };
                              });
                            });
                          dismissLoader();
                          setHelperText((pre) => {
                            pre.ifsc = "";
                            return { ...pre };
                          });
                          setBookingForm((pre) => {
                            // resp.data.data.full_name = resp.data.data.full_name.trim()
                            //   pre.customerBankDetails.accHolderName = pre.fistName;
                            return { ...pre };
                          });
                        } else {
                          setHelperText((pre) => {
                            pre.ifsc = "";
                            return { ...pre };
                          });
                        }
                      } else {
                        setHelperText((pre) => {
                          pre.ifsc = "ifsc code should be 11 digits";
                          return { ...pre };
                        });
                      }
                    }
                    return { ...pre };
                  });
                }}
                greenTick={accSuccess}
                placeholder={"Bank Ifsc Code"}
                label={"Bank Ifsc Code"}
                inputType={"text"}
                mandatory={true}
                helperText={helperText.ifsc}
                value={bookingForm.customerBankDetails.ifscCode}
              />
            </div>
            <div style={{ width: "50%" }}>
              <CustomInput
                placeholder={"Account Holder Name"}
                label={"Account Holder Name"}
                inputType={"text"}
                mandatory={true}
                disabled={true}
                value={bookingForm.customerBankDetails.accHolderName}
              />
            </div>
            <div style={{ width: "50%" }}>
              <CustomInput
                handleChange={(e) => {
                  setBookingForm((pre) => {
                    if (e === "") {
                      setHelperText((pre) => {
                        pre.bankName = "Please enter bank name";
                        return { ...pre };
                      });
                    } else {
                      setHelperText((pre) => {
                        pre.bankName = "";
                        return { ...pre };
                      });
                    }
                    let value = e;
                    value = value.replace(/[^A-Za-z^" "]/gi, "");

                    pre.customerBankDetails.bankName = value;
                    return { ...pre };
                  });
                }}
                placeholder={"Bank Name"}
                label={"Bank Name"}
                inputType={"text"}
                mandatory={true}
                helperText={helperText.bankName}
                value={bookingForm.customerBankDetails.bankName}
              />
            </div>
            <div style={{ width: "50%" }}>
              <DropDown
                list={["Savings", "Current"]}
                label={"Account Type"}
                placeHolder={"Account Type"}
                mandatory={true}
                selectedValue={
                  bookingForm.customerBankDetails.accType === ""
                    ? ""
                    : bookingForm.customerBankDetails.accType === "SB"
                    ? "Savings"
                    : "Current"
                }
                helperText={helperText.accType}
                onChangeSelect={(e) => {
                  setBookingForm((pre) => {
                    pre.customerBankDetails.accType =
                      e === "Savings" ? "SB" : "CB";
                    return { ...pre };
                  });
                  setHelperText((pre) => {
                    pre.accType = "";
                    return { ...pre };
                  });
                }}
              />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className={cssClasses.wrapperFooter}>
          <Button
            style={{
              color: "#ffffff",
              backgroundColor: "#155EEF",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
              width: "auto",
            }}
            disable={
              Object?.keys(helperText)?.filter((e) => {
                return helperText[e] !== "";
              })?.length > 0
                ? true
                : false || !isBankDetailAvailable || !isRequestRejected
              // ! commented because it is urgent to update on live
              // ! commented code is needed when details are rejected
              // ||
              // Object?.keys(updatedData ? updatedData : [])?.filter((e) => {
              //   return (
              //     updatedData[e] !== bookingForm?.customerBankDetails[e]
              //   );
              // })?.length === 0
            }
            btnName={updatedData ? "Update" : "Save"}
            clicked={() => {
              saveForm();
            }}
            //   disable={disabeNext}
          />
        </div>
      </div>
      {openConfirmationModal && (
        <ConfirmationAlert
          close={() => {
            setOpenConfirmationModal(false);
          }}
          open={openConfirmationModal}
          buttonTitle={"Cancel"}
          returnRespButton={"Yes I confirm"}
          title={"Warning"}
          subTitle={
            "Please ensure the bank details you have entered are correct"
          }
          confirm={(e) => {
            ModalResp(e);
          }}
        />
      )}
    </div>
  );
};

export default BankDetailForm;
